import React from "react"
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, Paper, Stack, Typography } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import AppsIcon from "@mui/icons-material/Apps"
import { statusLabel } from "./applicationColumns"

const Details = ({ title, fields }) => <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2, minWidth: 0 }}>
  <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>{title}</Typography>
  <Box component="dl" sx={{ m: 0, display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" }, gap: 2 }}>
    {fields.map(([label, value]) => <Box key={label}>
      <Typography component="dt" variant="body2" color="text.secondary">{label}</Typography>
      <Typography component="dd" variant="body2" sx={{ m: 0, mt: 0.5, fontWeight: 500, overflowWrap: "anywhere" }}>{value === null || value === undefined || value === "" ? "Not reported" : value}</Typography>
    </Box>)}
  </Box>
</Paper>

const ApproveApkMoreInfoMadal = ({ open, onClose, approvedData = {} }) => {
  const app = approvedData || {}
  const summary = app.appSummaryDtl || {}
  return <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" aria-labelledby="application-details-title"
    PaperProps={{ sx: { borderRadius: "10px", maxHeight: "90vh" } }}>
    <DialogTitle id="application-details-title" sx={{ bgcolor: "#116c6f", color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
      Application details
      <IconButton aria-label="Close application details" onClick={onClose} sx={{ color: "inherit" }}><CloseIcon /></IconButton>
    </DialogTitle>
    <DialogContent dividers sx={{ p: { xs: 2, sm: 3 } }}>
      <Stack spacing={2.5}>
        <Stack direction="row" spacing={2} alignItems="flex-start">
          <Box sx={{ width: 52, height: 52, flexShrink: 0, borderRadius: 2, bgcolor: "#e8f2f2", color: "#116c6f", display: "flex", alignItems: "center", justifyContent: "center" }}><AppsIcon /></Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" sx={{ fontSize: "1.1rem", overflowWrap: "anywhere" }}>{app.appName || "Unnamed application"}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, overflowWrap: "anywhere" }}>{app.appId || "Package name not reported"}</Typography>
            <Chip size="small" variant="outlined" color={app.status === "UPLOAD_NEW_APK" ? "info" : "default"} label={statusLabel(app.status)} sx={{ mt: 1 }} />
          </Box>
        </Stack>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, minmax(0, 1fr))" }, gap: 2 }}>
          {[["Total terminals", summary.totTerminals ?? app.totTerminals], ["Installations", summary.totInstallCount ?? app.totInstallCount], ["Downloads", app.totDownld]].map(([label, value]) =>
            <Paper key={label} variant="outlined" sx={{ p: 2, bgcolor: "#f4f8f8", borderRadius: 2 }}>
              <Typography variant="body2" color="text.secondary">{label}</Typography>
              <Typography variant="h4" sx={{ mt: 0.5, color: "#116c6f" }}>{value ?? "—"}</Typography>
            </Paper>)}
        </Box>
        <Details title="Application information" fields={[
          ["Application ID", app.applicationId], ["Organization code", app.orgCode],
          ["Version", app.appVersion], ["Version code", app.versionCode],
          ["Logo available", app.appLogo === true ? "Yes" : app.appLogo === false ? "No" : null],
        ]} />
        <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>Description</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{app.description?.trim() || "No description provided."}</Typography>
        </Paper>
        <Details title="Activity" fields={[["Uploaded", app.uploadOn], ["Created", app.createdDateTime]]} />
      </Stack>
    </DialogContent>
    <DialogActions sx={{ p: "1.25rem" }}>
      <Button onClick={onClose} variant="outlined" color="error">Close</Button>
    </DialogActions>
  </Dialog>
}

export default ApproveApkMoreInfoMadal
